const settings: ClientSettings = {
  name: "Ageucard",
  benefitCardName: "Cartão Consignado",
  theme: {
    token: {
      colorPrimary: "#102447",
      colorHighlight: "#E6B936",
    },
  },
  assets: {
    background: "/bg-ageucard.png",
    logo: "/logo-ageucard.png",
    logo_header: "/logo-ageucard.png",
    favicon: "/favicon-ageucard.png",
    card: "/card-ageucard.png",
    consignedCard: "/card-ageucard.png",
  },
  cardExclusiveTheme: {
    name: "Ageucard",
    theme: {
      token: {
        colorPrimary: "#102447",
        colorHighlight: "#E6B936",
      },
    },
    assets: {
      background: "/bg-ageucard.png",
      logo: "/logo-ageucard.png",
      logo_header: "/logo-ageucard.png",
      favicon: "/favicon-ageucard.png",
    },
  },
};

export default settings;
